import { supabase } from '@/lib/supabase'
import type { RewardsTrialAttempt } from '../types'

export async function getMyRewardsTrialAttempt(userId: string): Promise<RewardsTrialAttempt | null> {
  const uid = String(userId || '').trim()
  if (!uid) return null

  const { data, error } = await supabase
    .from('rewards_trial_attempts')
    .select('*')
    .eq('user_id', uid)
    .order('created_at', { ascending: false })
    .limit(1)
    .maybeSingle()
  if (error) throw error
  if (!data) return null
  const r: any = data
  return {
    id: r.id,
    user_id: r.user_id,
    account_id: r.account_id,
    status: r.status,
    selected_plan_id: r.selected_plan_id || null,
    stripe_customer_id: r.stripe_customer_id || null,
    stripe_subscription_id: r.stripe_subscription_id || null,
    started_at: r.started_at,
    check_deadline_at: r.check_deadline_at,
    trial_end_at: r.trial_end_at || null,
    min_volume_usdt: Number(r.min_volume_usdt || 0),
    volume_usdt_at_deadline: Number(r.volume_usdt_at_deadline || 0),
    passed: (r.passed as any) ?? null,
    evaluated_at: r.evaluated_at || null,
    fail_reason: r.fail_reason || null,
    override_volume_usdt: r.override_volume_usdt != null ? Number(r.override_volume_usdt) : null,
    override_passed: (r.override_passed as any) ?? null,
    override_note: r.override_note || null,
    overridden_by: r.overridden_by || null,
    overridden_at: r.overridden_at || null,
    created_at: r.created_at,
    updated_at: r.updated_at,
  }
}

